import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth.service.ts';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export default PrivateRoute;